<template>
  <div
    ref="myIdRef"
    class="input-slider-main"
  >
    <div
      class="input-slider-holder"
      :class="{ 'disabled-slider': $attrs.disable }"
    >
      <q-slider
        v-model="slideValue"
        :class="{ 'input-slider-markers': markers, 'input-slider-no-thumb': noThumb }"
        class="input-slider"
        :min="showAttribute(minValue)"
        :max="showAttribute(maxValue)"
        :step="showAttribute(steps)"
        snap
        :label-value="slideValue + labelValue"
        label
        :markers="markers"
        v-bind="$attrs"
      ></q-slider>
    </div>
    <div
      v-if="showMinMax"
      class="row slider-min-max"
      :class="{ 'disabled-slider': $attrs.disable }"
    >
      <div>{{ showAttribute(minValue) }}{{ labelValue }}</div>
      <div class="slider-min-max-right">{{ showAttribute(maxValue) }}{{ labelValue }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noThumb: {
      default: false,
    },
    value: {
      required: true,
      default: 1,
    },
    minValue: {
      default: 1,
    },
    maxValue: {
      default: 100,
    },
    steps: {
      default: 1,
    },
    labelValue: {
      default: '',
    },
    showMinMax: {
      type: Boolean,
      default: true,
    },
    idName: {
      type: String,
      default: '',
    },
    markers: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    slideValue: {
      get() {
        return Math.ceil(Number(this.value));
      },
      set(value) {
        this.$emit('handleChange', value);
        this.$emit('input', value);
      },
    },
  },

  mounted() {
    if (this.idName) this.$refs.myIdRef.setAttribute('id', this.idName);
  },
  methods: {
    showAttribute(obj) {
      if (obj === 0) return parseFloat(obj);
      return obj && !Number.isNaN(obj) ? parseFloat(obj) : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-slider-markers {
  :deep(.q-slider__track-container) {
    margin-top: 0;
  }
}
.input-slider-main {
  width: 100%;
}
.input-slider-no-thumb {
  :deep(.q-slider__thumb) {
    display: none;
  }
}
.input-slider-holder {
  background: $-system-app-background;
  border: 1px solid $-system-app-grey-95;
  border-radius: 30px;
  &.disabled-slider {
    color: $-system-app-grey-76;
    border: 1px solid $-system-app-border;
    .input-slider {
      opacity: initial !important;
    }
    cursor: initial !important;
    :deep(.q-slider__track-markers--h) {
      background-image: repeating-linear-gradient(to right, #bbc4c7, #bbc4c7 2px, transparent 0, transparent);
    }
    :deep(.q-slider__track) {
      color: $-status-status-offline !important;
    }
    :deep(.q-slider__inner) {
      background: $-status-status-offline !important;
    }
    :deep(.q-slider__thumb) {
      color: $-system-app-grey-76;
    }
  }
  :deep(.q-slider__track) {
    height: 2px !important;
    color: $-text--dark !important;
  }
  :deep(.q-slider__inner) {
    background: $-text--dark !important;
  }
  :deep(.q-slider__markers--h) {
    background-image: repeating-linear-gradient(to right, currentColor, $-system-app-background 2px, transparent 0, transparent);
  }
  :deep(.q-slider__thumb-container) {
    color: $-system-app-primary;
  }
}

.input-slider {
  display: block !important;
  width: 90%;
  height: 26px;
  margin: auto;
}

.slider-min-max {
  width: 91%;
  margin: 5px auto auto auto;
  font-size: 9px;
  font-weight: bold;
  line-height: 12px;
  text-align: right;
  .slider-min-max-right {
    margin-left: auto;
    float: right;
  }
  &.disabled-slider {
    color: $-system-app-grey-76;
  }
}
</style>
